<template>
  <div>
    <b-card no-header>
      <b-form>
        <b-form-group
          label="Banco"
          label-for="banco"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="banco" 
            :value="banco" 
            type="text"
            readonly>
          </b-form-input>
        </b-form-group>

        <b-form-group
          label="Tarjeta"
          label-for="tarjetaMarca"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="tarjetaMarca" 
            :value="tarjetaMarca"
            type="text"
            readonly>
          </b-form-input>
        </b-form-group>

        <b-form-group
          label="Nro.Cuenta"
          label-for="numeroCuenta"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="numeroCuenta" 
            :value="numeroCuenta" 
            type="text"
            readonly>
          </b-form-input>
        </b-form-group>

        <b-form-group
          label="Cierre"
          label-for="fechaCierre"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="fechaCierre" 
            :value="fechaCierre | fecha" 
            type="text"
            readonly>
          </b-form-input>
        </b-form-group>

        <b-form-group
          label="Vencimiento"
          label-for="fechaVencimiento"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="fechaVencimiento" 
            :value="fechaVencimiento | fecha" 
            type="text"
            readonly>
          </b-form-input>
        </b-form-group>

        <hr>

        <b-row>
          <b-col cols="6">
            <b-form-group
              label="Total"
              label-for="importePesos"
              :label-cols="labelColsImportes"
              horizontal>
              <b-form-input 
                id="importePesos" 
                :value="importePesos | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Pagado"
              label-for="importePagadoPesos"
              :label-cols="labelColsImportes"
              horizontal>
              <b-form-input 
                id="importePagadoPesos" 
                :value="importePagadoPesos | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Saldo"
              label-for="saldoPesos"
              :label-cols="labelColsImportes"
              horizontal>
              <b-form-input 
                id="saldoPesos"
                v-model.trim="$v.saldoPesos.$model" 
                :state="saldoPesosValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="saldoPesosFeedback">
                {{ saldoPesosInvalidoMsj }}  
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group
              label="Total"
              label-for="importeDolares"
              :label-cols="labelColsImportes"
              horizontal>
              <b-form-input 
                id="importeDolares" 
                :value="importeDolares | moneda('USD')" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Pagado"
              label-for="importePagadoDolares"
              :label-cols="labelColsImportes"
              horizontal>
              <b-form-input 
                id="importePagadoDolares" 
                :value="importePagadoDolares | moneda('USD')" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Saldo"
              label-for="saldoDolares"
              :label-cols="labelColsImportes"
              horizontal>
              <b-form-input 
                id="saldoDolares"
                v-model.trim="$v.saldoDolares.$model" 
                :state="saldoDolaresValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="saldoDolaresFeedback">
                {{ saldoDolaresInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>

      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button"
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, decimal } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'tarjetaResumenCierreSaldos/getField',
  mutationType: 'tarjetaResumenCierreSaldos/updateField',
});

export default {
  name: 'TarjetaResumenCierreSaldos',
  components: {
    appMensaje: Mensaje
  },
  mixins: [
    msjModal, 
  ],
  props: {
    tarjetaResumenId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      noValidar: true,
      saldoPesosValido: null,
      saldoPesosInvalidoMsj: '',
      saldoDolaresValido: null,
      saldoDolaresInvalidoMsj: '',

      labelCols: 2,
      labelColsImportes: 4
    }
  },
  computed: {
    ...mapFields([
      'banco',
      'tarjetaMarca',
      'numeroCuenta',
      'fechaCierre',
      'fechaVencimiento',
      'importePesos',
      'importePagadoPesos',
      'saldoPesos',
      'importeDolares',
      'importePagadoDolares',
      'saldoDolares',
    ])
  },  
  created() {
    this.showSpinner();
    this.$store.dispatch('tarjetaResumenCierreSaldos/inicializar', this.tarjetaResumenId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'saldoPesos' || validarTodos) {
        if (this.$v.saldoPesos.$error) {
          this.saldoPesosValido = false;
          if (!this.$v.saldoPesos.decimal) {
            this.saldoPesosInvalidoMsj = 'El saldo en pesos debe ser un valor numérico';
          }      
        } else {
          this.saldoPesosValido = null;
          this.saldoPesosInvalidoMsj = '';
        }
      }

      if (campo == 'saldoDolares' || validarTodos) {
        if (this.$v.saldoDolares.$error) {
          this.saldoDolaresValido = false;
          if (!this.$v.saldoDolares.decimal) {
            this.saldoDolaresInvalidoMsj = 'El saldo en dólares debe ser un valor numérico';
          }      
        } else {
          this.saldoDolaresValido = null;
          this.saldoDolaresInvalidoMsj = '';
        }
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('tarjetaResumenCierreSaldos/save')
            .then(() => this.showModalMsj('Los cambios se registraron con éxito', 
              this.close.bind(this, true), this.close.bind(this, true), 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        }
      } 
    },
    cancelar() {
      this.close(false);
    },
    close(saldoRegistrado) {
      this.$emit('close', saldoRegistrado);
    },
  },
  validations: {
    saldoPesos: { decimal },
    saldoDolares: { decimal }
  },   
}
</script>

<style>
</style>
